module.exports = __webpack_public_path__ + "img/athletics_icon_2.d264b31e.png";